import {LoyaltyLevel} from 'shared-lib';

export interface OnboardingData {
  merchantName?: string;
  merchantLogo?: string;
  loyaltyScore?: number;
  amountSpent?: number;
  firstVisit?: Date;
  loyaltyLevelAggregations: LoyaltyLevelAggregation[];
  recommendedCampaign?: RecommendedCampaign;
}

export interface LoyaltyLevelAggregation {
  level: LoyaltyLevel;
  count: number;
}


export const loyaltyLevelOrder = {
  [LoyaltyLevel.DEVOTED]: 1,
  [LoyaltyLevel.LOYAL]: 2,
  [LoyaltyLevel.FREQUENT]: 3,
  [LoyaltyLevel.CASUAL]: 4,
  [LoyaltyLevel.STRANGER]: 5,
};

export interface RecommendedCampaign {
  id: string;
  merchantName: string;
  merchantLogo?: string;
  reward: number;
}


